import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';


import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { JobSubject } from './../../../shared/models/jobSubject.model';


declare var jQuery: any;

@Component({
  selector: 'app-company-delete-widget',
  templateUrl: './company-delete-widget.component.html',
  styleUrls: ['./company-delete-widget.component.css']
})
export class CompanyDeleteWidgetComponent implements OnInit {


  // setup as observable?
  @Input() item_id?; // impliments on changes.
  @Input() item_data?; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full

  @Output()
change: EventEmitter<number> = new EventEmitter<number>();

//charts
    // Peity chart
  
  
    public peityType1:string = "bar";
    public peityOptions1:any = { fill: ['#1ab394', "#d7d7d7"], width:100};
  
    public peityType2 = "line";
    public peityOptions2:any = { fill: '#1ab394',stroke:'#169c81', width: 64 };
  
    // Sparkline chart
    public sparklineData:Array<any> = [5, 6, 7, 2, 0, 4, 2, 4, 5, 7, 2, 4, 12, 14, 4, 2, 14, 12, 7];
    public sparklineOptions:any = { type: 'bar', barWidth: 8, height: '150px', barColor: '#1ab394', negBarColor: '#c6c6c6'};
  
    public lineChartLabels:Array<any> = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    public lineChartType = 'line';
  
    public peityType = "pie";
    public peityOptions:any = { fill: ['#1ab394', '#d7d7d7', '#ffffff']};

@Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();


  job: Object;
  job_id;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  subject_id: any;
  subject: any;
  subject_number: any;
  job_number: string;
  model: JobSubject;
  assignedBrandList: any;
  assignedBrandList_count: any;
  assignedBrandList_removed: number;
  subject_count: any;
  subject_contact_emails: any;
  subject_contact_numbers: any;
  subject_model: any;
  subject_contact_emails_count: any;
  subject_contact_numbers_count: any;
  subject_notes: any;
  subject_notes_count: any;
  subject_services: any;
  subject_services_count: any;
  subject_files: any;
  subject_files_count: any;
  subject_system_log: any;
  subject_system_log_count: any;
  subject_communication_history: any;
  subject_communication_history_count: any;
  subject_invoices: any;
  subject_invoice_couunt: number;
  subject_work_orders: Object;
  subject_work_order_couunt: number;
  
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;
  subject_billing_items: any;
  subject_billing_items_count: any;
  subject_cost_items: any;
  subject_cost_items_count: any;
  subject_services_count_removed: number;
  subject_services_removed: number;
  assignedBrandList_count_removed: number;
  subject_contact_numbers_count_removed: number;
  subject_contact_numbers_removed: number;
  subject_contact_emails_removed: number;
  subject_contact_emails_count_removed: number;
  subject_notes_removed: number;
  subject_notes_count_removed: number;
  subject_files_removed: number;
  subject_files_count_removed: number;
  subject_logs_removed: number;
  subject_logs_count_removed: number;
  subject_communication_history_removed: number;
  subject_communication_history_count_removed: number;
  subject_billing_items_removed: number;
  subject_billing_items_count_removed: number;
  subject_cost_items_removed: number;
  subject_cost_items_count_removed: number;
  subject_removed: number;
  subject_count_removed: number;
  del_files: Object;
  job_subjects: any;
  job_subjects_count: any;
  job_notes: any;
  job_notes_count: any;
  job_files: any;
  job_files_count: any;
  job_system_log: any;
  job_system_log_count: any;
  job_plaintiffs: any;
  job_plaintiffs_count: any;
  job_report_subjects: any;
  job_report_subjects_count: any;
  job_billing_items: any;
  job_billing_items_count: any;
  job_cost_items: any;
  job_cost_items_count: any;
  job_count: any;
  job_notes_removed: number;
  job_notes_count_removed: number;
  job_files_removed: number;
  job_files_count_removed: number;
  job_logs_removed: number;
  job_logs_count_removed: number;
  job_plaintiffs_removed: number;
  job_plaintiffs_count_removed: number;
  job_report_subjects_removed: number;
  job_report_subjects_count_removed: number;
  job_removed: number;
  job_count_removed: number;
  brand_id: any;
  brand_types_all: any;
  brand_types: any;
  brand: any;
  brand_count: any;
  brand_jobs: any;
  brand_jobs_count: any;
  brand_notes: any;
  brand_notes_count: any;
  brand_services: any;
  brand_services_count: any;
  brand_files: any;
  brand_files_count: any;
  brand_system_log: any;
  brand_system_log_count: any;
  brand_communication_history: any;
  brand_communication_history_count: any;
  brand_billing_items: any;
  brand_billing_items_count: any;
  brand_cost_items: any;
  brand_cost_items_count: any;
  brand_invoices: any;
  brand_invoice_couunt: number;
  brand_invoice_count: number;
  brand_work_orders: any;
  brand_work_orders_count: any;
  brand_users: any;
  brand_users_count: any;
  brand_assigned_jobs: any;
  brand_assigned_jobs_count: any;
  brand_removal_valid: number;
  brand_removed: number;
  brand_count_removed: number;
  brand_sync_with_myob: any;
  brand_myob_id: any;

 constructor(
   private http: HttpClient, private _demoService: DemoService,
   private route: ActivatedRoute, public toastr: HotToastService,
    vcr: ViewContainerRef, private router: Router,
    public HttpClient:HttpClient,
    private fileUploader: FileUploaderService,
    private _mysqlService: MysqlService,
    private modalService: BsModalService,
    public datepipe: DatePipe,
    public gfunc: GlobalFunctionsService,
 ) {

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

   // need to add this as routes does not work globally
   this.all_router_details = this.router.url;
   this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));


  }

  // check for changes. to load data.
  ngOnChanges(changes) {
   if (changes.item_id) {
     // deal with asynchronous Observable result
     this.brand_id = changes.item_id.currentValue;
     // this.getJob(this.job_id);
    //  this.getJobSubject(this.subject_id);



   }
 }


 ngOnInit() {


  // brand functions
  this.getBrandById(this.brand_id);
  this.getBrandJobsTableDataGrid(this.brand_id, 'ALL', null); // gets jobs & Subjects
  this.getBrandAssignedJobsSubjectsTableDataGrid(this.brand_id, 'ALL', this.brand_id);
  this.getBrandNotes(this.brand_id);
  this.getBrandServices(this.brand_id);
  this.getBrandFiles(this.brand_id);
  this.getBrandSystemLogs(this.brand_id);
  this.getBrandCommunicationHistory(this.brand_id);
  this.getBrandBillingItems(this.brand_id);
  this.getBrandCostItems(this.brand_id);
  this.getBrandInvoices(this.brand_id);
  this.getBrandWorkOrders(this.brand_id);
  this.getBrandUsers(this.brand_id);
  this.checkBrandDelete();

  // Job Functions
// this.getJob(this.job_id);
// this.getJobSubjects(this.job_id);
// this.getJobNotes(this.job_id);
// this.getJobFiles(this.job_id);
// this.getJobSystemLogs(this.job_id);
// this.getJobPlaintiffs(this.job_id);
// this.getJobReportSubjects(this.job_id);
// this.getJobBillingItems(this.job_id);
// this.getJobCostItems(this.job_id);


  // All SUBJECT FUNCTIONS
  // this.getJobSubject(this.subject_id);
  //      // counts and datas
  //      this.getSubjectInvoices(this.subject_id);
  //      this.getSubjectAgentBrandsAssigned(this.subject_id);
  //      this.getSubjectContactEmails(this.subject_id);
  //      this.getSubjectContactNumbers(this.subject_id);

  //      this.getSubjectNotes(this.subject_id);
  //      this.getSubjectServices(this.subject_id);
  //      this.getSubjectFiles(this.subject_id);
  //      this.getSubjectSystemLogs(this.subject_id);
  //      this.getSubjectCommunicationHistory(this.subject_id);
  //      this.getSubjectWorkOrders(this.subject_id);
  
  //      this.getSubjectBillingItems(this.subject_id);
  //      this.getSubjectCostItems(this.subject_id);
  
 }




// ... Brand Company Functions

getBrandTypes() {
  this._demoService.getBrandBrandTypes().subscribe(
     data => { this.brand_types_all = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


 getBrandTypesNoOwner() {
  this._demoService.getBrandBrandTypesNoOwner().subscribe(
     data => { this.brand_types = data; },
     err => console.error(err),
     // () => console.log('done loading candidate for update')
   );
 }


 getBrandById(brand_id) {
  this._demoService.getBrandById(brand_id).subscribe(
    data => { this.brand = data;
      let res = data[0]
      this.brand_count = Object(this.brand).length; // counts the subjects.
      this.checkBrandDelete();
      this.brand_sync_with_myob = res.sync_with_myob;
      this.brand_myob_id = res.myob_id;
    },
    err => console.error(err),
    () => console.log('done loading company')
  );
}



getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent) {
  this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
    data => { this.brand_jobs = data;
      this.checkBrandDelete();
    let res = data;

      // removes all words with length of > 6
     // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);
     if (this.gfunc.sessionUserLevel === '9' ) { // client - remove these columns
     // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
     // res.filter( e => this.subjects_urgent.allocated_to);
     // send results back to array.
    // this.subjects_urgent = result_filter;
     }

      this.brand_jobs_count = this.brand_jobs.length;
      // pass so that the dates are correct in Sync
      // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
      // this.brand_jobs = DataUtil.parse.parseJson(data); 
     // console.log("Done loadng USER");
     // console.log(this.users);


    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  ); }



  getBrandAssignedJobsSubjectsTableDataGrid(brand_id, job_status_code, assigned_agent) {
    this._demoService.getBrandJobsTableDataGrid(brand_id, job_status_code, assigned_agent).subscribe(
      data => { this.brand_assigned_jobs = data;
        this.checkBrandDelete();
      let res = data;
  
        // removes all words with length of > 6
       // const result = this.subjects_urgent.filter(word => this.subjects_urgent.length > 6);
       if (this.gfunc.sessionUserLevel === '9' ) { // client - remove these columns
       // let result_filter = this.subjects_urgent.filter(subject => this.subjects_urgent.job_type_id);
       // res.filter( e => this.subjects_urgent.allocated_to);
       // send results back to array.
      // this.subjects_urgent = result_filter;
       }
  
        this.brand_assigned_jobs_count = this.brand_assigned_jobs.length;
        // pass so that the dates are correct in Sync
        // WORKED https://www.syncfusion.com/forums/152967/no-filter-result-using-date-column-in-ejs-grid-angular
        // this.brand_jobs = DataUtil.parse.parseJson(data); 
       // console.log("Done loadng USER");
       // console.log(this.users);
  
  
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }



// created by brand.
  getBrandNotes(brand_id) {
    this._demoService.getBrandNotes(brand_id).subscribe(
      data => { this.brand_notes = data;
        this.brand_notes_count = this.brand_notes.length;
        this.checkBrandDelete();
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }

    getBrandServices(brand_id) {
      this._demoService.getBrandServices(brand_id).subscribe(
        data => { this.brand_services = data;
          this.brand_services_count = this.brand_services.length;
          this.checkBrandDelete();
         // console.log("Done loadng USER");
         // console.log(this.users);
         let res = data[0];
         // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
         // this.getUsersById(res.who_attended);
        },
        error => {
        //  console.error('Error Loading User!');
        //return console.log(error);
        }
      ); }


      getBrandFiles(brand_id) {
        this._demoService.getBrandFiles(brand_id).subscribe(
           data => { this.brand_files = data;
          this.brand_files_count = this.brand_files.length;
          this.checkBrandDelete();
          },
           err => console.error(err),
            () => {
              console.log('done loading SCN');
                          }
              );
       }


       getBrandSystemLogs(brand_id) {
        this._demoService.getBrandSystemLogs(brand_id).subscribe(
           data => { this.brand_system_log = data;
          this.brand_system_log_count = this.brand_system_log.length;
          this.checkBrandDelete();
          },
           err => console.error(err),
            () => {
              console.log('done loading SCN');
                          }
              );
       }

       getBrandCommunicationHistory(brand_id) {
        this._demoService.getSubjectCommunicationHistory(brand_id).subscribe(
           data => { this.brand_communication_history = data;
          this.brand_communication_history_count = this.brand_communication_history.length;
          this.checkBrandDelete();
          },
           err => console.error(err),
            () => {
              console.log('done loading SCN');
                          }
              );
       };

       getBrandBillingItems(brand_id) {
        this._demoService.getBrandBillingItems(brand_id).subscribe(
          data => { this.brand_billing_items = data;
      this.brand_billing_items_count = this.brand_billing_items.length;
      this.checkBrandDelete();
           let res = data[0];
           // Run the job data queries.
         },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }


      getBrandCostItems(brand_id) {
        this._demoService.getBrandCostItems(brand_id).subscribe(
          data => { this.brand_cost_items = data;
            this.brand_cost_items_count = this.brand_cost_items.length;
            this.checkBrandDelete();
           let res = data[0];
           // Run the job data queries.
         },
          err => console.error(err),
          // () => console.log('done loading Trace Types')
        );
      }


      // clients
      getBrandInvoices(brand_id) {
        this._demoService.getBrandInvoices(brand_id).subscribe(
           data => { this.brand_invoices = data;
            this.brand_invoice_count = this.brand_invoices.length;
            this.checkBrandDelete();
         let res = data[0];
        // this.subject_invoices = res; // only return the first result and save back the the same variable.
         // do a count if exists
        //  let newArr = Object(this.brand_invoices);
        //  this.brand_invoice_count = Object.keys(newArr).length;
      
          }, // make the same data call for all
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }

       // agents
       getBrandWorkOrders(agent_id) {
        this._demoService.getBrandWorkOrders(agent_id).subscribe(
           data => { this.brand_work_orders = data;
            this.brand_work_orders_count = this.brand_work_orders.length;
            // maps to interface.(invoice_mode)
            this.checkBrandDelete();
          
          }, // make the same data call for all
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }



       
  getBrandUsers(brand_id) {
    this._demoService.getBrandUsers(brand_id)
      .subscribe(
        data => { this.brand_users = data;
        this.brand_users_count = this.brand_users.length;
        this.checkBrandDelete();
        let res = data[0];

        },
        err => console.error(err),
       //  () =>  console.log('loading L')
      );
  }



// Widget Delete Brand Functions
widgetDeleteBrand(model){
  // loop the function with the results 
  this.brand_removed = 0;
  this.brand_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     // Need to put in logic to check the subject number...??? what happens.
     this.deleteBrand(newArr[i].brand_id); // ready to once I fix the file delete
     // increases the count
     this.brand_count_removed++;

  }// end for loop

this.brand_removed = 1;

}

widgetDeleteAllBrandData() {
  if (confirm('Are you sure you want to delete this Compnay and all remaininbg data?.')) {
this.widgetDeleteBrand(this.brand);
}
}




  // Detet Brand Functions
  deleteBrand(brand_id) {
    // tslint:disable-next-line:max-line-length
    // if (confirm('Are you sure you want to delete ' + brand_id + ' , and any remaning data? This CANNOT BE UNDONE!')) {
      this._mysqlService.deleteBrand(brand_id).subscribe(
         data => {
           // refresh the list
           // this.getCustomers();
           // this.getTraceCandidates(trace_id);
           return true;
         },
         error => {
          this.brand_removed = 3;
           console.error('Error deleting Brand! Sorry Try Again');
          return console.log(error);
         }
      );
  // }
  }






 // Functions
getJob(job_id) {
 this._demoService.getJobID(job_id).subscribe(
    data => { this.job = data;
      this.job_count = Object(this.job).length; // counts the subjects.
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}





// :: JOB FUNCTIONS

getJobSubjects(job_id) {
  this._demoService.getJobSubjects(job_id).subscribe(
     data => { this.job_subjects = data;
      let res = data[0];
     // this.getSubjectNotes(res.subject_id);
      this.job_subjects_count = Object(this.job_subjects).length; // counts the subjects.
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobNotes(job_id) {
  this._demoService.getJobNotes(job_id).subscribe(
    data => { this.job_notes = data;
      this.job_notes_count = this.job_notes.length;
    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  ); }


  getJobFiles(job_id) {
    this._demoService.getJobFiles(job_id).subscribe(
       data => { this.job_files = data;
      this.job_files_count = this.job_files.length;
      },
       err => console.error(err),
        () => {
          console.log('done loading SCN');
                      }
          );
   }

   getJobSystemLogs(job_id) {
    this._demoService.getJobSystemLogs(job_id).subscribe(
       data => { this.job_system_log = data;
      this.job_system_log_count = this.job_system_log.length;
      },
       err => console.error(err),
        () => {
          console.log('done loading SCN');
                      }
          );
   }

   getJobPlaintiffs(job_id) {
    this._demoService.getJobPlaintiffs(job_id).subscribe(
       data => { this.job_plaintiffs = data;
        this.job_plaintiffs_count = this.job_plaintiffs.length;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  


   getJobReportSubjects(job_id) {
    this._demoService.getJobReportSubjects(job_id).subscribe(
       data => { this.job_report_subjects = data;
        this.job_report_subjects_count = this.job_report_subjects.length;
        // map the results.
        // this.subjectReportList = this.job_report_subjects.map(s => ({
        //   subject_id: s.subject_id,
        //   subject_number: s.subject_number
        //    }));
  
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }
  
  
 getJobBillingItems(job_id) {
  this._demoService.getJobBillingItems(job_id).subscribe(
    data => { this.job_billing_items = data;
this.job_billing_items_count = this.job_billing_items.length;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}

getJobCostItems(job_id) {
  this._demoService.getJobCostItems(job_id).subscribe(
    data => { this.job_cost_items = data;
      this.job_cost_items_count = this.job_cost_items.length;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}
  



// :: Widget Delete Functions
widgetDeleteJobNotes(model){
  // loop the function with the results 
  this.job_notes_removed = 0;
  this.job_notes_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteJobNotes(newArr[i].job_id);
     // increases the count
     this.job_notes_count_removed++;

  }// end for loop

this.job_notes_removed = 1;

}

widgetDeleteJobFiles(model){
  // loop the function with the results 
  this.job_files_removed = 0;
  this.job_files_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
    //  console.log(newArr[i].file_subject_id);
    //  this.deleteSubjectFiles(newArr[i].file_subject_id);

    // this should now remove the file and the physical file
    this.deleteSystemJobFile(newArr[i]);

     // increases the count
     this.job_files_count_removed++;

  }// end for loop

this.job_files_removed = 1;

}

widgetDeleteJobLogs(model){
  // loop the function with the results 
  this.job_logs_removed = 0;
  this.job_logs_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteJobLogs(newArr[i].job_id);
     // increases the count
     this.job_logs_count_removed++;

  }// end for loop

this.job_logs_removed = 1;

}

widgetDeleteJobPlaintiffs(model){
  // loop the function with the results 
  this.job_plaintiffs_removed = 0;
  this.job_plaintiffs_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteJobPlaintiffs(newArr[i].job_id);
     // increases the count
     this.job_plaintiffs_count_removed++;

  }// end for loop

this.job_plaintiffs_removed = 1;

}



widgetDeleteJobReportSubjects(model){
  // loop the function with the results 
  this.job_report_subjects_removed = 0;
  this.job_report_subjects_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteJobReportSubjects(newArr[i].job_id);
     // increases the count
     this.job_report_subjects_count_removed++;

  }// end for loop

this.job_report_subjects_removed = 1;

}


widgetDeleteJob(model){
  // loop the function with the results 
  this.job_removed = 0;
  this.job_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     // Need to put in logic to check the subject number...??? what happens.
     this.deleteJob(newArr[i].job_id); // ready to once I fix the file delete
     // increases the count
     this.job_count_removed++;

  }// end for loop

this.job_removed = 1;

}


widgetDeleteAllJobData() {
  if (confirm('Are you sure you want to delete this Job and all remaininbg subject data and files.')) {
this.widgetDeleteJobNotes(this.job_notes);
this.widgetDeleteJobFiles(this.job_files);
this.widgetDeleteJobLogs(this.job_system_log);
this.widgetDeleteJobPlaintiffs(this.job_plaintiffs);
this.widgetDeleteJobReportSubjects(this.job_report_subjects);
this.widgetDeleteJob(this.job);
}
}




// JOB DELETE FUNCTIONS

deleteJobNotes(job_id) {
  this._demoService.deleteJobNotes(job_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.job_notes_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}


deleteJobLogs(job_id) {
  this._demoService.deleteJobLogs(job_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.job_logs_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}



deleteJobPlaintiffs(job_id) {
    this._demoService.deleteJobPlaintiffs(job_id).subscribe(
       data => {
     // reset the plaintiff list.
   
       },
       error => {
        this.job_plaintiffs_removed = 3;
         console.error('Error deleting !');
        return console.log(error);
       }
    );
}



deleteJobReportSubjects(job_id) {
  this._demoService.deleteJobReportSubjects(job_id).subscribe(
     data => {
   // reset the plaintiff list.
     },
     error => {
      this.job_plaintiffs_removed = 3;
       console.error('Error deleting !');
      return console.log(error);
     }
  );

}



deleteJob(job_id) {
  this._demoService.deleteJob(job_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.job_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}



// :: SUBJECT FUNCTIONS







getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
    data => { this.subject = data;
      let res = data[0];
      this.subject_number = res.subject_number;
      this.job_number = res.job_id + '.1'; // made up
      this.subject_count = this.subject.length;
     // console.log("Done loadng USER");
    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  );
 }


 // Gets
 getSubjectAgentBrandsAssigned(subject_id) {
  this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
     data => { this.assignedBrandList = data;
      let res = data[0];
      this.assignedBrandList_count = this.assignedBrandList.length;
      this.assignedBrandList_removed = 0;

    },
     err => console.error(err),
    // // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }



 getSubjectContactEmails(subject_id) {
  this._demoService.getSubjectContactEmails(subject_id).subscribe(
     data => { this.subject_contact_emails = data; 
    this.subject_contact_emails_count = this.subject_contact_emails.length;
    
    },
     err => console.error(err),
      () => {
        console.log('done loading SR');
                    }
        );
 }

getSubjectContactNumbers(subject_id) {
  this._demoService.getSubjectContactNumbers(subject_id).subscribe(
     data => { this.subject_contact_numbers = data;
    this.subject_contact_numbers_count = this.subject_contact_numbers.length;
    },
     err => console.error(err),
      () => {
        console.log('done loading SCN');
                    }
        );
 }



 getSubjectNotes(subject_id) {
  this._demoService.getSubjectNotes(subject_id).subscribe(
    data => { this.subject_notes = data;
      this.subject_notes_count = this.subject_notes.length;
     // console.log("Done loadng USER");
     // console.log(this.users);
    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  ); }




  getSubjectServices(subject_id) {
    this._demoService.getSubjectServices(subject_id).subscribe(
      data => { this.subject_services = data;
        this.subject_services_count = this.subject_services.length;
       // console.log("Done loadng USER");
       // console.log(this.users);
       let res = data[0];
       // this.getSubjectServiceOutcome(res.subject_service_outcome_id);
       // this.getUsersById(res.who_attended);
      },
      error => {
      //  console.error('Error Loading User!');
      //return console.log(error);
      }
    ); }



    getSubjectFiles(subject_id) {
      this._demoService.getSubjectFiles(subject_id).subscribe(
         data => { this.subject_files = data;
        this.subject_files_count = this.subject_files.length;
        },
         err => console.error(err),
          () => {
            console.log('done loading SCN');
                        }
            );
     }


     getSubjectSystemLogs(subject_id) {
      this._demoService.getSubjectSystemLogs(subject_id).subscribe(
         data => { this.subject_system_log = data;
        this.subject_system_log_count = this.subject_system_log.length;
        },
         err => console.error(err),
          () => {
            console.log('done loading SCN');
                        }
            );
     }


     getSubjectCommunicationHistory(subject_id) {
      this._demoService.getSubjectCommunicationHistory(subject_id).subscribe(
         data => { this.subject_communication_history = data;
        this.subject_communication_history_count = this.subject_communication_history.length;
        },
         err => console.error(err),
          () => {
            console.log('done loading SCN');
                        }
            );
     }     


     getSubjectInvoices(subject_id) {
      this._demoService.getSubjectInvoices(subject_id).subscribe(
         data => { this.subject_invoices = data;
       let res = data[0];
      // this.subject_invoices = res; // only return the first result and save back the the same variable.
       // do a count if exists
       let newArr = Object(this.subject_invoices);
       this.subject_invoice_couunt = Object.keys(newArr).length;
    
        }, // make the same data call for all
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
     

     getSubjectWorkOrders(subject_id) {
      this._demoService.getSubjectWorkOrders(subject_id).subscribe(
         data => { this.subject_work_orders = data;
       let res = data[0];
      // this.subject_invoices = res; // only return the first result and save back the the same variable.
       // do a count if exists
       let newArr = Object(this.subject_work_orders);
       this.subject_work_order_couunt = Object.keys(newArr).length;
    
        }, // make the same data call for all
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }



     
getSubjectBillingItems(subject_id) {
  this._demoService.getSubjectBillingItems(subject_id).subscribe(
    data => { this.subject_billing_items = data;
this.subject_billing_items_count = this.subject_billing_items.length;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}


getSubjectCostItems(subject_id) {
  this._demoService.getSubjectCostItems(subject_id).subscribe(
    data => { this.subject_cost_items = data;
      this.subject_cost_items_count = this.subject_cost_items.length;
     let res = data[0];
     // Run the job data queries.
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}







// deletes (widget mutilple functions)





widgetDeleteSubjectAgentsAssigned(model){
  // loop the function with the results 
  this.assignedBrandList_removed = 0;
  this.assignedBrandList_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteSubjectAgentAssignedAll(null, this.subject_id);
     // increases the count
     this.assignedBrandList_count_removed++;

  }// end for loop

this.assignedBrandList_removed = 1;

}

widgetDeleteSubjectContactEmails(model){
  // loop the function with the results 
  this.subject_contact_emails_removed = 0;
  this.subject_contact_emails_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectContactEmails(newArr[i].subject_id);
     // increases the count
     this.subject_contact_emails_count_removed++;

  }// end for loop

this.subject_contact_emails_removed = 1;

}


widgetDeleteSubjectContactNumbers(model){
  // loop the function with the results 
  this.subject_contact_numbers_removed = 0;
  this.subject_contact_numbers_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectContactNumbers(newArr[i].subject_id);
     // increases the count
     this.subject_contact_numbers_count_removed++;

  }// end for loop

this.subject_contact_numbers_removed = 1;

}

widgetDeleteSubjectNotes(model){
  // loop the function with the results 
  this.subject_notes_removed = 0;
  this.subject_notes_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectNotes(newArr[i].subject_id);
     // increases the count
     this.subject_notes_count_removed++;

  }// end for loop

this.subject_notes_removed = 1;

}


widgetDeleteSubjectServices(model){
  // loop the function with the results 
  this.subject_services_count_removed = 0;
  this.subject_services_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectsServices(newArr[i].subject_id);
     // increases the count
     this.subject_services_count_removed++;

  }// end for loop

this.subject_services_removed = 1;

}


widgetDeleteSubjectFiles(model){
  // loop the function with the results 
  this.subject_files_removed = 0;
  this.subject_files_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     console.log(newArr[i].file_subject_id);
    //  this.deleteSubjectFiles(newArr[i].file_subject_id);

    // this should now remove the file and the physical file
    this.deleteSystemJobFile(newArr[i]);

     // increases the count
     this.subject_files_count_removed++;

  }// end for loop

this.subject_files_removed = 1;

}


widgetDeleteSubjectLogs(model){
  // loop the function with the results 
  this.subject_logs_removed = 0;
  this.subject_logs_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     this.deleteSubjectLogs(newArr[i].subject_id);
     // increases the count
     this.subject_logs_count_removed++;

  }// end for loop

this.subject_logs_removed = 1;

}


widgetDeleteSubjectCommunicationHistory(model){
  // loop the function with the results 
  this.subject_communication_history_removed = 0;
  this.subject_communication_history_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectCommunicationHistory(newArr[i].subject_id);
     // increases the count
     this.subject_communication_history_count_removed++;

  }// end for loop

this.subject_communication_history_removed = 1;

}


widgetDeleteSubjectBillingItems(model){
  // loop the function with the results 
  this.subject_billing_items_removed = 0;
  this.subject_billing_items_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectAllBillingItems(newArr[i].subject_id);
     // increases the count
     this.subject_billing_items_count_removed++;

  }// end for loop

this.subject_billing_items_removed = 1;

}

widgetDeleteSubjectCostItems(model){
  // loop the function with the results 
  this.subject_cost_items_removed = 0;
  this.subject_cost_items_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
     this.deleteSubjectAllCostItems(newArr[i].subject_id);
     // increases the count
     this.subject_cost_items_count_removed++;

  }// end for loop

this.subject_cost_items_removed = 1;

}


widgetDeleteSubject(model){
  // loop the function with the results 
  this.subject_removed = 0;
  this.subject_count_removed = 0;

  let newArr = model;
  let  count_of_items = Object.keys(newArr).length;
  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];

     // Need to put in logic to check the subject number...??? what happens.
     this.deleteSubject(newArr[i].subject_id); // ready to once I fix the file delete
     // increases the count
     this.subject_count_removed++;

  }// end for loop

this.subject_removed = 1;

}


widgetDeleteAllSubjectData() {
    if (confirm('Are you sure you want to delete this subject and all subject data and files.')) {
  this.widgetDeleteSubjectAgentsAssigned(this.assignedBrandList);
  this.widgetDeleteSubjectContactEmails(this.subject_contact_emails);
  this.widgetDeleteSubjectContactNumbers(this.subject_contact_numbers);
  this.widgetDeleteSubjectNotes(this.subject_notes);
  this.widgetDeleteSubjectServices(this.subject_services);
  this.widgetDeleteSubjectFiles(this.subject_files);
  this.widgetDeleteSubjectLogs(this.subject_system_log);
  this.widgetDeleteSubjectCommunicationHistory(this.subject_communication_history);
  this.widgetDeleteSubjectBillingItems(this.subject_billing_items);
  this.widgetDeleteSubjectCostItems(this.subject_cost_items);
  this.widgetDeleteSubject(this.subject);
}
}


// single delete functions



deleteSubjectAgentAssignedAll(item, subject_id) {
  this._demoService.deleteSubjectAgentAssignedAll(item, subject_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
    // this.toastr.success('Agents All Removed');
    //  this.getSubjectAgentAssigned(subject_id);
       return true;
     },
     error => {
       this.assignedBrandList_removed = 3; 
       console.error('Error removing all users from list!');
       return error(error.error);
     }
  );
  
  }
  





 deleteSubjectContactEmails(subject_id) {
  this._demoService.deleteSubjectContactEmails(subject_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
      // this.toastr.success('Subject Contact Email Removed');
       },
     err => {
      this.subject_contact_emails_removed = 3;
      console.error(err)
    },
      () => {
      //  console.log('done loading SR');
                    }
        );
}


 deleteSubjectContactNumbers(subject_id) {
  this._demoService.deleteSubjectContactNumbers(subject_id).subscribe(
     data => { 
      // this.subject_contact_emails = data;
       },
     err => {
      this.subject_contact_emails_removed = 3;
      console.error(err)
    },
      () => {
      //  console.log('done loading SR');
         }
        );

}



deleteSubjectNotes(subject_id) {
  this._demoService.deleteSubjectNotes(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_notes_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}




deleteSubjectFiles(subject_id) {
  this._demoService.deleteSubjectFiles(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_files_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}





deleteSubjectsServices(subject_id) {
    this._demoService.deleteSubjectsServices(subject_id).subscribe(
       data => {
        // resets the count
        // this.getSubjectServices(this.subject_id);
        //  return true;
       },
       error => {
        this.subject_services_removed = 3; // reports error.
         console.error('Error deleting subject service!');
        return console.log(error);
       }
    );
}




deleteSubjectService(subject_service_id) {
  if (confirm('Are you sure you want to delete this Service Information? ')) {
    this._demoService.deleteSubjectService(subject_service_id).subscribe(
       data => {
       // this.getSubjectServices(this.subject_id);
        // this.gfunc.globalJobSubjectViewSkipRoute(this.subject_id);
         return true;
       },
       error => {
         console.error('Error deleting Attendence!');
        return console.log(error);
       }
    );
}
}

deleteSubjectLogs(subject_id) {
  this._demoService.deleteSubjectLogs(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_logs_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}


deleteSubjectCommunicationHistory(subject_id) {
  this._demoService.deleteSubjectCommunicationHistory(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_communication_history_removed = 3;
      console.error(err)},
    // () => console.log('done loading Trace Types')
  );
}



deleteSubjectAllBillingItems(subject_id) {
  this._demoService.deleteSubjectAllBillingItems(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_billing_items_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}


deleteSubjectAllCostItems(subject_id) {
  this._demoService.deleteSubjectAllCostItems(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.

    },
    err => {
      this.subject_cost_items_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}



deleteSubject(subject_id) {
  this._demoService.deleteSubject(subject_id).subscribe(
    data => { // this.subject_billing_items = data;
    // let res = data[0];
     // Run the job data queries.
  //  this.toastr.success('Subject Billing Item Removed.');
  
    },
    err => {
      this.subject_removed = 3;
      console.error(err); 
    },
    // () => console.log('done loading Trace Types')
  );
}



// this deletes the lot!
deleteSystemJobFile(model) {
  console.log('FileID: ', model.file_id);
  // change into a subscruption and delete the file action.
// 1: delete from database + Log action
this.deleteSystemFileAssigned(model);
// 2: Delete file from server
this.deleteSystemFile(model);
// logg the process
// this.gfunc.insertLog_DeleteSystemFile(model);
// 3: Delete the pysical file from the server file
if (model.file_server_location !== '') {
this.deleteJobFileAny(model.full_file_name, model.file_job_id, model.file_make, model.file_server_location);
console.log('physicalFILEdelete active: ');
// find out what type of tile it is and then detete the file.
}
console.log('Success: Data + File deleted', model.file_id + ' ' + model.full_file_name);
// this.refreshGrid();
  // this.router.navigate(['/admin/system-file-manager/system-file/' + file_id + '']);
 // this.gfunc.globalViewSystemFile(file_id);

}




deleteSystemFileAssigned(model){
  this._demoService.deleteSystemFileAssigned(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('Assigned Files deleted', model.file_id + ' ' + model.full_file_name)
      // this.files_table = this.files.slice(0, 10)
      ),
    (err) => console.error(err.status)
  );
}

deleteSystemFile(model){
  this._demoService.deleteSystemFile(model).subscribe(
    (res) => (
      this.del_files = res,
      console.log('File deleted', model.file_id + ' ' + model.full_file_name)
      // this.files_table = this.files.slice(0, 10)
      ),
    (err) => console.error(err.status)
  );
}


// New delete any job or subject file fuction - Beta Testing
deleteJobFileAny(filename, job_id, file_make, file_server_location) {
  // if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFileAny(filename, job_id, file_make, file_server_location).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        return console.log(error);
       }
    );
// }
}



// :: General Functions

 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel2() {
  //  alert('parent component function.');
    this.modalRef.hide();
 };


refreshPage(){
  // reload all the counts.
  this.getBrandById(this.brand_id);
  this.getBrandJobsTableDataGrid(this.brand_id, 'ALL', null); // gets jobs & Subjects
  this.getBrandAssignedJobsSubjectsTableDataGrid(this.brand_id, 'ALL', this.brand_id);
  this.getBrandNotes(this.brand_id);
  this.getBrandServices(this.brand_id);
  this.getBrandFiles(this.brand_id);
  this.getBrandSystemLogs(this.brand_id);
  this.getBrandCommunicationHistory(this.brand_id);
  this.getBrandBillingItems(this.brand_id);
  this.getBrandCostItems(this.brand_id);
  this.getBrandInvoices(this.brand_id);
  this.getBrandWorkOrders(this.brand_id);
  this.getBrandUsers(this.brand_id);
  this.checkBrandDelete();

  //   this.getJob(this.job_id);
// this.getJobSubjects(this.job_id);
// this.getJobNotes(this.job_id);
// this.getJobFiles(this.job_id);
// this.getJobSystemLogs(this.job_id);
// this.getJobPlaintiffs(this.job_id);
// this.getJobReportSubjects(this.job_id);
// this.getJobBillingItems(this.job_id);
// this.getJobCostItems(this.job_id);
// refresh the counts
// this.job_notes_removed= null;
// this.job_notes_count_removed= null;
// this.job_files_removed= null;
// this.job_files_count_removed= null;
// this.job_logs_removed= null;
// this.job_logs_count_removed= null;
// this.job_plaintiffs_removed= null;
// this.job_plaintiffs_count_removed= null;
// this.job_report_subjects_removed= null;
// this.job_report_subjects_count_removed= null;
// this.job_removed= null;
// this.job_count_removed= null;

}

checkBrandDelete(){
  this.brand_removal_valid = 1;

  // if (this.brand_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_jobs_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_notes_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_services_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_files_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_system_log_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_communication_history_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_billing_items_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_cost_items_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_invoice_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_work_orders_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_users_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_assigned_jobs_count > 0) {this.brand_removal_valid = 0;};
  if (this.brand_myob_id != null && this.brand_sync_with_myob != 0) {this.brand_removal_valid = 0; };


  // if any above find a result it well present 0! so 1 is true is this case.
};



}